<div style="display: block">
  <canvas
    [legend]="pieChartLegend"
    [plugins]="pieChartPlugins"
    height="300px"
    baseChart
    [data]="pieChartData"
    [options]="pieChartOptions"
    [type]="pieChartType"
  >
  </canvas>
</div>
